/**
 * Get token
 *
 * @param {String} key
 * @returns {String|null}
 */
export function getLocalToken(key = 'dms_admin_access_token') {
  let token = null
  try {
    token = localStorage.getItem(key)
  } catch (ex) {
    token = null
  }
  return token
}

/**
 * Set token
 *
 * @param {String} key
 * @param {String} value
 * @returns {String|null}
 */
export function setLocalToken(key, value) {
  try {
    localStorage.setItem(key, value)
  } catch (ex) {}
}

/**
 * Delete token
 *
 * @param {String} key
 * @returns {String|null}
 */
export function deleteLocalToken(key = 'dms_admin_access_token') {
  try {
    token = localStorage.removeItem(key)
  } catch (ex) {}
}

// Storage keys
export const DMSAccessTokenKey = 'dms_admin_access_token'
export const DMSRefreshTokenKey = 'dms_admin_refresh_token'



// WEBPACK FOOTER //
// ./src/apps/auth/utils/index.js